module.exports = __webpack_public_path__ + "img/reviews-01.d9b65cc4.png";